
export const EXPENSE_CATS = [
  'Alimentação', 'Compras', 'Hospedagem', 'Lazer', 'Outro', 'Transporte',
] as const;

export const EXPENSE_CAT_ICONS: Record<string, string> = {
  'Alimentação': '🍽️',
  'Compras':     '🛍️',
  'Hospedagem':  '🏨',
  'Lazer':       '🎭',
  'Outro':       '📌',
  'Transporte':  '🚌',
};

export const COMMON_CURRENCIES = [
  { code: 'BRL', symbol: 'R$',  label: 'Real Brasileiro'   },
  { code: 'USD', symbol: '$',   label: 'Dólar Americano'   },
  { code: 'EUR', symbol: '€',   label: 'Euro'               },
  { code: 'GBP', symbol: '£',   label: 'Libra Esterlina'   },
  { code: 'ARS', symbol: '$',   label: 'Peso Argentino'    },
  { code: 'CLP', symbol: '$',   label: 'Peso Chileno'      },
  { code: 'COP', symbol: '$',   label: 'Peso Colombiano'   },
  { code: 'MXN', symbol: '$',   label: 'Peso Mexicano'     },
  { code: 'PYG', symbol: '₲',   label: 'Guarani Paraguaio' },
  { code: 'UYU', symbol: '$',   label: 'Peso Uruguaio'     },
  { code: 'JPY', symbol: '¥',   label: 'Iene Japonês'      },
  { code: 'CHF', symbol: 'Fr',  label: 'Franco Suíço'      },
  { code: 'CAD', symbol: 'CA$', label: 'Dólar Canadense'   },
  { code: 'AUD', symbol: 'A$',  label: 'Dólar Australiano' },
] as const;

export const AGENDA_CATS = [
  'Café', 'Compras', 'Cultura', 'Entretenimento',
  'Esporte', 'Gastronomia', 'Hospedagem', 'Natureza', 'Outro', 'Transporte',
] as const;

export const AGENDA_STATUS = [
  'confirmado', 'feito', 'pendente',
] as const;

export const AGENDA_CAT_ICONS: Record<string, string> = {
  'Café':           '☕',
  'Compras':        '🛍️',
  'Cultura':        '🏛️',
  'Entretenimento': '🎭',
  'Esporte':        '⛷️',
  'Gastronomia':    '🍽️',
  'Hospedagem':     '🏨',
  'Natureza':       '🌿',
  'Outro':          '📌',
  'Transporte':     '🚌',
};

export const AGENDA_STATUS_CONFIG: Record<string, { label: string; cls: string }> = {
  'confirmado': { label: 'Confirmado', cls: 'b-ok'   },
  'pendente':   { label: 'Pendente',   cls: 'b-warn' },
  'feito':      { label: 'Feito',      cls: 'b-info' },
};

export const AGENDA_VIEW_MODES = ['timeline', 'cards', 'compact'] as const;
export type AgendaViewMode = typeof AGENDA_VIEW_MODES[number];

// ─────────────────────────────────────────────────────────────
// Constants — Single source of truth for all magic strings
// ─────────────────────────────────────────────────────────────

export const TRANSPORT_TYPES = [
  'Carro', 'Ferry', 'Metrô', 'Ônibus', 'Trem', 'Voo', 'Outro',
] as const;

export const STATUS_OPTIONS = [
  'cancelado', 'confirmado', 'pendente',
] as const;

export const CHECK_CATS = [
  'Documentos', 'Finanças', 'Logística', 'Outros', 'Saúde',
] as const;

export const COMPRA_CATS = [
  'Alimentação', 'Documentos', 'Eletrônicos', 'Farmácia',
  'Higiene', 'Lembrança', 'Outros', 'Roupas',
] as const;

export const DOC_CATS = [
  'Outros', 'Passaporte', 'Reservas', 'Seguro viagem', 'Vacinas', 'Visto',
] as const;

export const COTACAO_CATS = [
  'hotel', 'ingresso', 'outro', 'transporte',
] as const;

export const COTACAO_CAT_LABELS: Record<string, string> = {
  hotel:       'Hotel',
  transporte:  'Transporte',
  ingresso:    'Ingresso / Atração',
  outro:       'Outro',
};

export const COTACAO_STATUS = [
  'confirmado', 'descartado', 'em análise',
] as const;

export const TRIP_EMOJIS = [
  '✈️','🌍','🏖️','🏔️','🗺️','🏛️','🌴','🚂','🛳️','🎭',
  '🍷','⛷️','🏄','🎒','📸','🌸','🌊','🏕️','🎪','🌅',
  '🗼','🎡','🏟️','🌋',
] as const;

export const TRIP_COLORS = [
  '#378add','#639922','#ba7517','#7f77dd','#d85a30','#0f6e56',
  '#993556','#2a7fc1','#c17f2a','#1a6b8a','#7a4f9a','#2e7d32',
  '#c62828','#37474f','#4e342e','#1565c0',
] as const;

// Session storage keys
export const SESSION_KEYS = {
  CURRENT_TRIP_ID: 'travelle-current-trip',
  CURRENT_TAB:     'travelle-current-tab',
} as const;

// Toast durations
export const TOAST_DURATION = {
  SHORT:  2500,
  NORMAL: 3500,
  LONG:   5000,
} as const;

// Pagination
export const USERS_PER_PAGE = 10;
